import clsx from "clsx";
import React, { useContext } from "react";

import { FrontendEvaluation } from "@client/components/round/allocator/useEvaluatorEvaluationsCache";
import { Tooltip } from "@client/components/utils/Tooltip";
import PinIcon from "@client/icons/PinIcon";
import PinSlashIcon from "@client/icons/PinSlashIcon";
import { PinnedNodesContext } from "@client/pages/round/Round";
import { Evaluation, Funder, Recommender } from "@engine/round/aggregate";
import { Evaluable } from "@lib/types";
import { EvaluableCardControlsMenu } from "./EvaluableCardControlsMenu";

export function EvaluableCardControls({
  evaluable,
  evaluator,
  evaluation,
}: {
  evaluable: Evaluable;
  evaluator?: Recommender | Funder;
  evaluation?: FrontendEvaluation | Evaluation;
}) {
  const { pinnedNodes, togglePinNode } = useContext(PinnedNodesContext);
  const pinned = pinnedNodes.includes(evaluable.id);

  const [modalIsOpen, setIsOpen] = React.useState(false);

  function onModalOpen() {
    setIsOpen(true);
  }

  function onModalClose() {
    setIsOpen(false);
  }

  function clickHandler(e: React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
    e.preventDefault();
    if (evaluable.type === "proposal") {
      togglePinNode(evaluable.id);
    } else {
      onModalOpen();
    }
  }

  return (
    <div
      className={clsx(
        "z-30 dark:text-white pl-1",
        modalIsOpen || pinned ? "flex" : "hidden group-hover:flex",
      )}
    >
      <div className="flex items-center">
        {evaluable.type === "proposal" && (
          <div onClick={clickHandler}>
            <Tooltip
              title={pinned ? "Unhighlight node" : "Keep node highlighted"}
            >
              {pinned ? <PinSlashIcon /> : <PinIcon />}
            </Tooltip>
          </div>
        )}
        <EvaluableCardControlsMenu
          evaluable={evaluable}
          evaluator={evaluator}
          onPopperShow={onModalOpen}
          onPopperHide={onModalClose}
          evaluation={evaluation}
        />
      </div>
    </div>
  );
}
